import { render, staticRenderFns } from "./ReportMenu.vue?vue&type=template&id=6687a88a&scoped=true"
import script from "./ReportMenu.vue?vue&type=script&lang=js"
export * from "./ReportMenu.vue?vue&type=script&lang=js"
import style0 from "./ReportMenu.vue?vue&type=style&index=0&id=6687a88a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687a88a",
  null
  
)

export default component.exports